import {isProduction} from '../constants'

const isBrowser = () => typeof window !== 'undefined'

export const isIgnored = () => {
	return !isProduction && isBrowser() && window.ignoreTranslations
}
